import RetryPayment from "@/views/crud/modules/RetryPayment.vue";

export default {
    key: "payment_result_detail",
    id: "id",
    // type: "readonly",
    export: ["excel"],
    excel: {
        //max_row: "50000"
    },
    sort: {
        field: "id",
        order: "desc"
    },
    sort_fields: [
        "id"
    ],
    action: ["view"],
    options:[],
    fields:[
        {key :"id"},
        {
            key :"resultId",
            type: "href",
            url:"cp_rsr/",
            url_key:[
                {
                    search_key:"payment_result_id",
                    row_key:"resultId",
                    str:""
                }
            ]
        },
        {key: "referenceMemberId"},
        {
            key :"paymentType",
            type: "href",
            display_val:["Voucher"],
            url:"voucher/",
            url_key:[
                {
                    search_key:"rsrId",
                    row_key:"referenceRsrId",
                    str:""
                }
            ]
        },
        {key : "amount"},
        {key : "currentUnitSession"},
        {key: "startTime", type: "datetime"},
        {key: "endTime", type: "datetime"},
        {key: "autoPaymentExpiredTime", type: "datetime"},
        {key: "gracingPeriodEndDttm", type: "datetime"},
        {key: "actualFinishedTime", type: "datetime"},
        {key : "penaltyDuration"},
        // {key : "chargingFee"},
        // {key : "penaltyFee"},
        {key: "point"},
        {key: "redeemVoucherSessions"},
        {key: "status"},
        {key: "actionType" },
        {key :"requestReference"},
        {key: "transactionReference"},
        {key: "creDttm", type: "datetime"},
        {key: "lupdDttm", type: "datetime"},
        {key: "shkOrderReferenceNum", privilege:["cstDebug"]},
        {key: "shkHeader", privilege:["cstDebug"]},
        // { type: "action-btn" },
        {key: "retry", type: "components", component: RetryPayment, width:60, privilege:["READ_RETRY_ERROR_PAYMENT"]},
        {key: "action_button", type: "action-btn", width: "50px"},
    ],
    view: [
        ["id", "resultId"],
        ["referenceMemberId", "paymentType"],
        ["amount", "currentUnitSession"],
        [{key: "startTime", type: "datetime"}, {key: "endTime", type: "datetime"}],
        [{key: "autoPaymentExpiredTime", type: "datetime"}, {key: "gracingPeriodEndDttm", type: "datetime"}],
        [{key: "actualFinishedTime", type: "datetime"}, "penaltyDuration"],
        ["point", "status"],
        ["actionType"],
        ["requestReference"],
        ["transactionReference"],
        [{key: "creDttm", type: "datetime"}, {key: "lupdDttm", type: "datetime"}]
    ],
    filters:{
        id:{},
        resultId:{},
        referenceMemberId:{},
        paymentType:{},
        status:{},
        actionType:{},
        currentUnitSession:{},
        creDttm:{
            type: "daterange"
        },
        lupdDttm: {
            type: "daterange"
        },
        startTime: {            type: "daterange"
        },
        endTime:{            type: "daterange"
        }
    }
}